import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-date-picker-widget',
  templateUrl: './date-picker-widget.component.html',
  styleUrls: ['./date-picker-widget.component.scss']
})
export class DatePickerWidgetComponent {

  date = new Date();
  @Output() handleSubmitResponse = new EventEmitter();
  isDisabled = false;

  @Input() canChangeStyle: any;
  @Input() clientConfigurationData: any;
  styleSheet: CSSStyleSheet | undefined;
  DATA: any;

  ngOnInit(): void {
    if (this.canChangeStyle) {
      this.DATA = this.clientConfigurationData;
      this.fnSetStyles();
    } else {
      this.fnSetDefaultStyles();
    }
  }


  submitDate() {
    this.isDisabled = true;
    this.handleSubmitResponse.emit(this.date);
  }

  fnSetStyles() {
    let style = document.createElement("style");
    style.appendChild(document.createTextNode(""));
    document.head.appendChild(style);
    this.styleSheet = style.sheet as CSSStyleSheet;

    this.styleSheet.insertRule(`.date-picker {
      background: `+ this.DATA.PrimaryColor + ` !important;	
    }`);

  }

  fnSetDefaultStyles() {
    let style = document.createElement("style");
    style.appendChild(document.createTextNode(""));
    document.head.appendChild(style);
    this.styleSheet = style.sheet as CSSStyleSheet;
    this.styleSheet.insertRule(`.date-picker  {
      background: `+ '#156087' + ` !important;	
    }`);
  }

}
